<template>
    <div class="flex-row flex justify-start items-center">
        <component
            v-for="(i, index) in gradeLength"
            :key="index"
            :is="'StarIcon'"
            :fillClass="i > modelValue ? 'fill-transparent' : 'fill-primary'"
            :class="'mr-2 cursor-pointer transform hover:scale-110'"
            :strokeClass="'stroke-primary'"
            @click="$emit('change', index + 1)"
        />
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "InputGrades",
    props: {
        modelValue: {
            required: true,
        },
        gradeLength: {
            type: Number,
            default: 5,
        },
    },
    emits: ["change"],
});
</script>
